import { getConfig } from '@cian/config/browser';
import { getEventQueue } from '../../../shared/utils/eventQueue';
import { IApplicationState } from '../../../shared/types/redux';
import { createReduxStore } from '../../../shared/utils/store';
import { getHttpApi } from '@cian/http-api/browser';
import { getLogger } from '@cian/logger/browser';
import { registry as getRegistry } from '@cian/mf-registry/browser';

export function createApplicationState() {
  const config = getConfig();
  const eventQueue = getEventQueue();
  const httpApi = getHttpApi();
  const logger = getLogger();
  const microfrontendsRegistry = getRegistry();

  const initialState = config.getStrict<IApplicationState>('initialState');

  const reduxContext = {
    config,
    httpApi,
    logger,
    microfrontendsRegistry,
    eventQueue,
  };

  return {
    config,
    httpApi,
    eventQueue,
    logger,
    store: createReduxStore(initialState, reduxContext),
    microfrontendsRegistry,
  };
}
